import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar } from "@/components/UserAvatar";

export default function MembersPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [members, setMembers] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/members", { params: { q } }).then((r) => setMembers(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="members-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="label-accent">The squad</div>
          <h1 className="font-display text-4xl sm:text-5xl mt-1">Members</h1>
        </div>
        <div className="relative w-full sm:w-80">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--hb-muted)]" />
          <input className="hb-input !pl-9" placeholder="Search name, business, location..." value={q}
            onChange={(e) => setQ(e.target.value)} data-testid="members-search-input" />
        </div>
      </div>
      {members?.length === 0 && <p className="mt-10 text-[var(--hb-muted)]" data-testid="members-empty">No members match that search.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {members?.map((m, i) => (
          <button key={m.id} onClick={() => navigate(`/members/${m.id}`)} style={{ animationDelay: `${i * 40}ms` }}
            className="hb-card p-6 text-left rise hover:border-[var(--hb-ink)] hover:-translate-y-0.5 transition-transform"
            data-testid={`member-card-${m.id}`}>
            <div className="flex items-center gap-4">
              <UserAvatar user={m} size={56} />
              <div className="min-w-0">
                <div className="font-display text-lg truncate">{m.name}</div>
                <div className="text-sm text-[var(--hb-muted)] truncate">{m.business || "Hey Boo! member"}</div>
              </div>
            </div>
            {m.bio && <p className="text-sm mt-4 line-clamp-2">{m.bio}</p>}
            <div className="flex items-center justify-between mt-4">
              <span className="text-xs text-[var(--hb-muted)] flex items-center gap-1">{m.location && <><MapPin size={12} />{m.location}</>}</span>
              {m.role === "admin" && <span className="label-accent !text-[9px] bg-[var(--hb-ink)] !text-[var(--hb-lime)] px-1.5 py-0.5 rounded">Host</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
